import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, IconButton, Menu, MenuItem, useTheme, Box, Grid } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import { useThemeMode } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffOutlined';

export default function UserProfileMenu({ anchorEl, setAnchorEl, handleMenu, handleClose, open }) {
    const { user, logout, saveThemeMode } = useAuth()
    const navigate = useNavigate();
    const theme = useTheme();
    const { mode } = useThemeMode();

    // Flip the theme and persist the choice for the logged-in account.
    const handleToggleTheme = () => {
        saveThemeMode(mode === 'dark' ? 'light' : 'dark');
    };

    const commonIconButtonStyles = {
        '&:hover': {
            color: 'text.active', // Using theme tokens directly
            bgcolor: 'button.active',
        },
    };

    return (
        <>
            <IconButton
                color="inherit"
                aria-label="حساب کاربری"
                onClick={handleMenu}
                sx={{
                    width: 40,
                    height: 40,
                    flexShrink: 0,
                    color: theme.palette.primary.contrastText,
                    background: theme.palette.brand.gradient,
                    borderRadius: '.7rem',
                    '&:hover': {
                        background: theme.palette.brand.gradient,
                        filter: 'brightness(1.1)',
                    },
                    '& .MuiSvgIcon-root': { fontSize: '1.4rem' },
                }}
            >
                <PersonIcon />
            </IconButton>

            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        backgroundColor: theme.palette.background.default,
                        backgroundImage: 'none',
                        padding: '1rem',
                        width: '240px'
                    },
                }}
            >
                <Grid container direction="column" spacing={2}>
                    {user && (
                        <Grid item>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginLeft: '1rem', marginBottom: '.6rem' }}>
                                <Typography variant="body2">
                                    نام کاربری:
                                </Typography>
                                <Typography variant="body2">
                                    {user.first_name} {user.last_name}
                                </Typography>

                            </Box>
                            {/* The header hides the institute name below md;
                                keep it reachable here instead of repeating it
                                on every page. */}
                            {user.institute_name && (
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginLeft: '1rem', gap: 1 }}>
                                    <Typography variant="body2">
                                        آموزشگاه:
                                    </Typography>
                                    <Typography variant="body2" sx={{ textAlign: 'left' }}>
                                        {user.institute_name}
                                    </Typography>
                                </Box>
                            )}
                        </Grid>
                    )}

                    <Grid item>
                        <MenuItem onClick={handleToggleTheme}
                            sx={{ ...commonIconButtonStyles, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            زمینه تیره
                            {mode === 'dark' ? <ToggleOnIcon sx={{fontSize: '1.2rem' }}/> : <ToggleOffOutlinedIcon sx={{fontSize: '1.2rem' }}/>}
                        </MenuItem>
                    </Grid>

                    <Grid item>
                        <MenuItem onClick={() => { logout(); navigate('/login'); handleClose(); }}
                            sx={{ ...commonIconButtonStyles, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            خروج
                            <LogoutIcon sx={{fontSize: '1.2rem' }}/>
                        </MenuItem>
                    </Grid>
                </Grid>
            </Menu>

        </>
    )
}